import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { parse } from 'query-string';

import { redirectToConsole } from '../actions';
import { StoreState } from '../types';

import SetupComplete from '../components/SetupComplete';

export default connect(
  null,
  mapDispatchToProps
)(
  class SetupCompleteContainer extends React.Component<
    SetupCompleteContainerProps,
    SetupCompleteContainerState
  > {
    constructor(props: SetupCompleteContainerProps) {
      super(props);

      const params = parse(location.search);
      let email = '';
      if (params.email) {
        // convert provided email to lowercase (LOGIN-144)
        email = params.email.toLowerCase();
      }

      this.state = {
        busy: false,
        email
      };
    }

    render() {
      const { busy, email } = this.state;
      return (
        <SetupComplete
          busy={busy}
          email={email}
          handleSubmit={this.handleSubmit}
        />
      );
    }

    handleSubmit = (event: React.SyntheticEvent<HTMLFormElement>) => {
      event.preventDefault();
      this.setState({ busy: true });
      this.props.redirectToConsole();
    };
  }
);

export interface SetupCompleteContainerProps {
  redirectToConsole(): void;
}

export interface SetupCompleteContainerState {
  busy: boolean;
  email: string;
}

function mapDispatchToProps(dispatch: Dispatch<StoreState>) {
  return {
    redirectToConsole() {
      dispatch(redirectToConsole());
    }
  };
}
